import { jsx as c } from "react/jsx-runtime";
import { useMemo as l, useCallback as g } from "react";
import { convertPresetToDateSource as i, setPermittedPresetLabels as m } from "./index.es2483.js";
import { DatePickerList as M } from "./index.es5708.js";
import { useRelativePreset as b } from "./index.es5824.js";
import { useDatePicker as A } from "./index.es851.js";
import C from "classnames";
import { DATEPICKER_PANEL_RELATIVE_TESTID as _ } from "./index.es2485.js";
import n from "./index.es5825.js";
const F = ({ activePreset: S, setActivePreset: u }) => {
  const { maxDate: h, userDatePresets: R, id: x, setSelectedRangeData: d, redundantLabelsByPanel: s, variant: E } = A(), { toMaxDate: r, fullPeriod: o, passPeriod: a } = b(h, R), L = _ + x, p = l(() => i(r), [r]), P = l(() => i(o), [o]), f = l(() => i(a), [a]), T = g(
    (e) => {
      const t = r[e] || o[e] || a[e];
      u(e), d({
        ...t,
        activePanel: "relative"
      });
    },
    [r, o, a, u, d]
  ), I = l(() => {
    const e = [], t = m(
      "relative",
      p,
      s
    ), v = m(
      "relative",
      P,
      s
    ), D = m(
      "relative",
      f,
      s
    );
    return t.length && e.push(t), v.length && e.push(v), D.length && e.push(D), e;
  }, [P, f, s, p]), N = C(n.container, {
    [n.collapsed]: E === "collapsed"
  });
  return /* @__PURE__ */ c("div", { "data-testid": L, className: N, children: I.map((e, t) => /* @__PURE__ */ c("div", { className: n.column, children: /* @__PURE__ */ c(
    M,
    {
      className: n.list,
      dataSource: e,
      activeItem: S,
      displayAsList: !0,
      onSelect: T
    }
  ) }, t)) });
};
export {
  F as RelativePanel
};
//# sourceMappingURL=index.es5712.js.map
